"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRoutes = void 0;
const auth_route_1 = require("./auth_route");
class AdminRoutes extends auth_route_1.AuthRoute {
    constructor() {
        super('admin');
    }
    /**
     * Force resets the PIN for a user account.
     * @param { string } accountId
     */
    resetPin(accountId) {
        return this.post(`/pin`, { accountId });
    }
}
exports.AdminRoutes = AdminRoutes;
//# sourceMappingURL=admin.js.map